import React from "react";
import { Icon } from "@blueprintjs/core";
import CircleImage from "../../Image/CircleImage";
export default function NotificationItem({ notification, onClick }) {
  const isUnread = notification["unread"] ? notification["unread"] : false;
  let itemClass = "item";
  if (isUnread) {
    itemClass += " unread";
  }
  return (
    <div className={itemClass} onClick={_ => onClick(notification)}>
      <div className="image">
        <CircleImage size="small" src={notification["t_url"]} alt={notification["title"]} />
      </div>
      <div className="meta">
        <div className="context">{notification["title"]}</div>
        <div className="message">{notification["message"]}</div>
        <div className="timestamp">{notification["c_at"]}</div>
      </div>
      <Icon icon="chevron-right" iconSize="16" className="icon more-indicator" />
    </div>
  );
}
